import { useCallback, useMemo, useState } from 'react';
import * as React from 'react';
import { Toast, TOAST_ID } from 'palette/Toast';
import ToastContext from './ToastContext';
import { ToastProps } from './types';

type ToastContextProviderProps = React.PropsWithChildren<{}>;

function ToastContextProvider({ children }: ToastContextProviderProps) {
    const [toastList, setToastList] = useState<ToastProps[]>([]);

    const addToast = useCallback((toast: ToastProps) => {
        const findToast = toastList?.find(item => item.id === toast.id);

        if (!toast.autoHideDuration) toast.autoHideDuration = 3000;
        toast.id = `${Math.random()}`;
        if (!toast.wrapperId) { toast.wrapperId = TOAST_ID.general; }

        if (!findToast) { setToastList([...toastList, toast]); }
    }, [toastList]);

    const removeToast = useCallback((toastId: string) => {
        const listExcept = toastList?.filter(item => item.id !== toastId) || [];

        setToastList(listExcept);
    }, [toastList]);

    const contextValue = useMemo(() => ({
        toastList,
        setToastList,
        addToast,
        removeToast,
    }), [addToast, removeToast, toastList]);

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            <Toast
                autoHide
                isFloating
                position="bottom-right"
                toastId={TOAST_ID.general}
            />
        </ToastContext.Provider>
    );
}

export default ToastContextProvider;
